import { SET_CURRENT_DEVICE } from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.current, action = {type: ''}) => {
    switch (action.type) {
        case SET_CURRENT_DEVICE:
            return action.payload;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/currentDevice.js